export default {
  allSuppliers(state) {
    return state.suppliers;
  },
  selectedSupplier(state) {
    return state.selectedSupplier;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/getters.js